import { EventEmitter, Injectable } from '@angular/core';
import { MsalService } from 'msal';

// import { MsalService } from 'msal';

@Injectable()
export class AuthenticationService {

  public isLoading: EventEmitter<any>;
  public Partnerdetail: any;


  public readonly authConfiguration: any;
  public readonly protectedResourceMap: Map<string, Array<string>>;

  constructor(authConfig: any, protectedResourceMap: Map<string, Array<string>>) {
    this.authConfiguration = authConfig;
    this.protectedResourceMap = protectedResourceMap;

    this.isLoading = new EventEmitter();
  }

  public getUserRoles(msalService: MsalService) {
    let msalAccount: any = msalService?.instance.getActiveAccount() || msalService.instance.getAllAccounts()[0];
    return msalAccount.idTokenClaims.roles;
  }

  public getCurrentUser(msalService: MsalService) {
    let msalAccount: any = msalService?.instance.getActiveAccount() || msalService.instance.getAllAccounts()[0];
    const roles = msalAccount.idTokenClaims.roles;
    const currentUser = {
      UserId: msalAccount.name,
      UserName: msalAccount.name,
      RoleName: "Admin", //for now
      administrationAccess: roles.indexOf("APDigitize-SitePublisher") !== -1 || roles.indexOf("APDigitize-SiteAdmin") !== -1,
      pdmUser: roles.indexOf("PDM-ReadOnly") !== -1,
      apdigitizeUser: roles.indexOf("APDigitize-SiteReadOnly") !== -1,
      workflow: roles.indexOf("PDM-ReadOnly") !== -1,
      addUniversity: roles.indexOf("PDM-Admin") !== -1,
      carouselUser: roles.indexOf("APCarousel-Admin") !== -1,
      DataIntakeUser: roles.indexOf("DataIntake-ReadOnly") !== -1,
      TemplateManagerUser: roles.indexOf("TemplateManager-ReadOnly") !== -1,
      Permissions: roles.filter((role: any) => role.startsWith("DATA_INTAKE")).join(),
      acdemicServiceUser: roles.indexOf("PDM-AcademicServices") !== -1,
      financeProfessionalUser: roles.indexOf("FinanceProfessional") !== -1,
      editPermission: roles.indexOf("PDM-Admin") !== -1 ||
        roles.indexOf("PDM-ManagingDirector") !== -1 ||
        roles.indexOf("PDM-PartnerEnablement") !== -1,
      partnerEnablementUser: roles.indexOf("PDM-PartnerEnablement") !== -1
    }
    return currentUser;

  }

  checkLoading(isload: boolean) {
    setTimeout(() => {
      this.isLoading.emit(isload);
    }, 0);
  }

  setPartnerdetail(partner) {
    this.Partnerdetail = partner;
  }

  getPartnerdetail() {
    return this.Partnerdetail;
  }

  GetSolutionList(msalService: MsalService) {
    const currentUser = this.getCurrentUser(msalService);
    const solutionList = [
      {
        name: "Partner Data",
        alias: "Partner Data Manager",
        idName: "PartnerData",
        imageSrc: "assets/images/partnerdata-icn.png",
        id: "1",
        perm: currentUser.pdmUser,
        defaultPage: "/partnerdata",
        UserGroup: 'APEdge'
      },
      // {
      //   name: "AP Digitize",
      //   alias: "AP Digitize",
      //   idName: "Digitize",
      //   imageSrc: "assets/images/ap-digitize-icn.png",
      //   id: "2",
      //   perm: currentUser.apdigitizeUser,
      //   defaultPage: "/digitize",
      //   UserGroup: 'APDigitize'
      // },
      {
        name: "WorkFlow",
        alias: "WorkFlow",
        idName: "WorkFlow",
        imageSrc: "assets/images/partnerdata-icn.png",
        id: "3",
        perm: currentUser.workflow,
        defaultPage: "/workflow",
        UserGroup: 'APEdge'
      },
      // {
      //   name: "Carousel",
      //   alias: "Carousel",
      //   idName: "Carousel",
      //   imageSrc: "assets/images/carousel-icn.png",
      //   id: "4",
      //   perm: currentUser.carouselUser,
      //   defaultPage: "/carousel/program",
      //   UserGroup: 'APCarousel'
      // },
      // {
      //   name: "Template Manager",
      //   alias: "Template Manager",
      //   idName: "Template Manager",
      //   imageSrc: "assets/images/partnerdata-icn.png",
      //   id: "6",
      //   perm: currentUser.TemplateManagerUser,
      //   defaultPage: "/APTemplate/#/Templates/EmailTemplates",
      //   UserGroup: 'APTemplate'
      // },
      {
        name: "Data Intake",
        alias: "Data Intake",
        idName: "DataIntake",
        imageSrc: "assets/images/integration-port-ico.png",
        id: "5",
        perm: currentUser.DataIntakeUser,
        defaultPage: "/dataintake",
        UserGroup: 'APIntegrationPortal'
      }      
    ];
    return solutionList;
  }

}
